export const CityData = [
  {
    value: '基隆市',
    text: '基隆市',
    index: 1
  },
  {
    value: '臺北市',
    text: '臺北市',
    index: 2
  },
  {
    value: '新北市',
    text: '新北市',
    index: 3
  },
  {
    value: '桃園市',
    text: '桃園市',
    index: 4
  },
  {
    value: '新竹市',
    text: '新竹市',
    index: 5
  },
  {
    value: '新竹縣',
    text: '新竹縣',
    index: 6
  },
  {
    value: '苗栗縣',
    text: '苗栗縣',
    index: 7
  },
  {
    value: '臺中市',
    text: '臺中市',
    index: 8
  },
  {
    value: '彰化縣',
    text: '彰化縣',
    index: 9
  },
  {
    value: '南投縣',
    text: '南投縣',
    index: 10
  },
  {
    value: '雲林縣',
    text: '雲林縣',
    index: 11
  },
  {
    value: '嘉義市',
    text: '嘉義市',
    index: 12
  },
  {
    value: '嘉義縣',
    text: '嘉義縣',
    index: 13
  },
  {
    value: '臺南市',
    text: '臺南市',
    index: 14
  },
  {
    value: '高雄市',
    text: '高雄市',
    index: 15
  },
  {
    value: '屏東縣',
    text: '屏東縣',
    index: 16
  },
  {
    value: '臺東縣',
    text: '臺東縣',
    index: 17
  },
  {
    value: '花蓮縣',
    text: '花蓮縣',
    index: 18
  },
  {
    value: '宜蘭縣',
    text: '宜蘭縣',
    index: 19
  },
  {
    value: '澎湖縣',
    text: '澎湖縣',
    index: 20
  },
  {
    value: '金門縣',
    text: '金門縣',
    index: 21
  },
  {
    value: '連江縣',
    text: '連江縣',
    index: 22
  }
];
